// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/accordion/jquery.accordion.scss
// module id = 320
// module chunks = 0